import { status } from "../_constants/commonIVY"
import { matterConstant } from "../_constants/matter.constant"

let InitialState = {}

export function matterDetails(state = InitialState, action) {
    switch (action.type) {

        case matterConstant.CREATE_MATTER_REQUEST:
            return {
                ...state,
                create_matter_status: status.IN_PROGRESS,
                create_matter_data: null,
            }
        case matterConstant.CREATE_MATTER_SUCCESS:
            return {
                ...state,
                create_matter_status: status.SUCCESS,
                create_matter_data: action.data
            }
        case matterConstant.CREATE_MATTER_FAILURE:
            return {
                ...state,
                create_matter_status: status.FAILURE,
                create_matter_data: action.data
            }
        case matterConstant.GET_MATTER_REQUEST:
            return {
                ...state,
                matter_status: status.IN_PROGRESS,
                matter_data: null,
            }
        case matterConstant.GET_MATTER_SUCCESS:
            return {
                ...state,
                matter_status: status.SUCCESS,
                matter_data: action.data,
            }
        case matterConstant.GET_MATTER_FAILURE:
            return {
                ...state,
                matter_status: status.FAILURE,
                matter_data: action.data
            }
        default:
            return state;
    }
}